module.exports = __webpack_public_path__ + "images/4e5f47b.png";